import { KSendError } from '@asset-metrix/poco-api-client-js';
import { KSendErrorDto } from '@asset-metrix/portal-gateway-client-js';
import { isObject } from '@asset-metrix/portal-ui';

const isPortalGatewayKSendError = (val: unknown): val is KSendErrorDto => {
  if (!isObject(val)) {
    return false;
  }
  return (
    ['error', 'fail'].includes(`${val.status}`) &&
    val.data !== null &&
    isObject(val.data)
  );
};

const isPocoKsendError = (val: unknown): val is KSendError => {
  if (!isObject(val)) {
    return false;
  }
  return ['error', 'fail'].includes(`${val.status}`);
};

export function extractErrorMessage(error: unknown, defaultMessage?: string) {
  if (typeof error === 'string') {
    return error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  if (isPortalGatewayKSendError(error)) {
    const data = error.data;
    return typeof data?.message === 'string' ? data.message : error.message;
  }
  if (isPocoKsendError(error)) {
    return error.message;
  }

  return defaultMessage ?? JSON.stringify(error);
}
